var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36113 0C2.8478 0 0 2.75093 0 6.14476C0 10.7533 6.36113 16.13 6.36113 16.13C6.36113 16.13 12.7223 10.7533 12.7223 6.14476C12.7223 2.75093 9.87446 0 6.36113 0Z",
    fill: "#00B0A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21649 2.87817C5.30049 2.87817 4.422 3.22968 3.77429 3.85536C3.12658 4.48104 2.7627 5.32965 2.7627 6.2145C2.7627 7.09934 3.12658 7.94795 3.77429 8.57363C4.422 9.19931 5.30049 9.55082 6.21649 9.55082C7.1325 9.55082 8.01098 9.19931 8.6587 8.57363C9.30641 7.94795 9.67029 7.09934 9.67029 6.2145C9.67029 5.32965 9.30641 4.48104 8.6587 3.85536C8.01098 3.22968 7.1325 2.87817 6.21649 2.87817Z",
    fill: "#FFFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocator);
export default __webpack_public_path__ + "static/media/locator.a9887f5b2ffdd39f454c451fd53a8ec3.svg";
export { ForwardRef as ReactComponent };